import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { getLanguageColor } from '../common/languageUtils';

const { FiTag, FiBox } = FiIcons;

export default function SnippetCard({ snippet, onClick }) {
  // Handle tags that might be comma-separated strings or arrays
  const tags = typeof snippet.tags === 'string' 
    ? snippet.tags.split(',').filter(Boolean) 
    : (snippet.tags || []);

  const languageStyles = getLanguageColor(snippet.language);

  return (
    <div 
      onClick={onClick}
      className="bg-slate-900 border border-slate-800 rounded-xl p-5 hover:border-indigo-500/50 hover:shadow-lg hover:shadow-indigo-500/5 transition-all cursor-pointer group flex flex-col h-full"
    >
      <div className="flex items-center justify-between mb-4">
        <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider border ${languageStyles}`}>
          {snippet.language}
        </span>
        <div className="flex items-center gap-1.5 text-slate-500 text-[11px] font-medium">
          <SafeIcon icon={FiBox} className="w-3 h-3" />
          {snippet.framework}
        </div>
      </div>
      
      <h3 className="text-lg font-bold text-slate-100 mb-2 group-hover:text-indigo-400 transition-colors line-clamp-1">
        {snippet.title}
      </h3>
      
      <p className="text-slate-400 text-sm mb-6 line-clamp-2 flex-grow leading-relaxed">
        {snippet.description}
      </p>
      
      <div className="flex flex-wrap gap-1.5 mt-auto pt-4 border-t border-slate-800/50">
        {tags.slice(0, 3).map(tag => (
          <span 
            key={tag} 
            className="flex items-center gap-1 text-[10px] bg-slate-800 text-slate-400 px-2 py-0.5 rounded border border-slate-700/50"
          >
            <SafeIcon icon={FiTag} className="w-2.5 h-2.5 opacity-50" />
            {tag}
          </span>
        ))}
        {tags.length > 3 && (
          <span className="text-[10px] text-slate-600 self-center">+{tags.length - 3} more</span>
        )}
      </div>
    </div>
  );
}